import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges, OnInit, signal, SimpleChanges } from "@angular/core";
import { FUNCTION_RESULT_STATUS, IObjectKey } from "@nova/common-interfaces";
import { IPaymentMethod } from "@rfm/shared-interfaces";
import { MenuItem } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { MenuModule } from "primeng/menu";
import { BoolToTextPipe } from "../../../../../lib/pipes/index.mjs";
import { CustomerService } from "../../../../shared/services/customers/customers.service.mjs";
import { ThirdPartyStripeService } from "../../../../shared/services/third-party/stripe/third-party-stripe.service";

@Component({
  selector: "app-payment-methods",
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, MenuModule, BoolToTextPipe],
  templateUrl: "./payment-methods.component.html",
  styleUrls: ["./payment-methods.component.scss"],
})
export class PaymentMethodsComponent implements OnInit, OnChanges {
  @Input()
  customer = signal<IObjectKey | undefined>(undefined);

  payment_methods = signal<IPaymentMethod[] | undefined>(undefined);

  activeRow: IPaymentMethod | undefined;

  items: MenuItem[] = [
    {
      label: "Delete",
      icon: "pi pi-delete",
      command: () => this.delete(this.activeRow!.id),
    }
  ];

  async delete(payment_method_id: string)
  {
    await this.stripeService.removePaymentMethod(payment_method_id);
    await this.refreshData();
  }

  constructor(
    protected stripeService: ThirdPartyStripeService,
    protected customerService: CustomerService
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.customer())
    {
      this.refreshData();
    }
  }

  ngOnInit() {
  }

  async refreshData() {
    await this.customerService.get(this.customer()!.id).then((result) => {
      if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
        const stripeCustomerId = result.data?.reference_keys.data.find(
          (x) => x.name == "stripe"
        )?.referenceId;

        console.log("Stripe Customer ID", stripeCustomerId);

        this.stripeService
          .getPaymentMethods(stripeCustomerId!)
          .then((result) => {
            console.log("methods", result);
            if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
              this.payment_methods.set(result.data);
            }
          });
      }
    });    
  }

    menuClicked(rowData: IPaymentMethod) {
      this.activeRow = rowData;
    }
}
